import { render } from "./ColorRefPage.vue?vue&type=template&id=2f344001&scoped=true"
import script from "./ColorRefPage.vue?vue&type=script&lang=js"
export * from "./ColorRefPage.vue?vue&type=script&lang=js"

import "./ColorRefPage.vue?vue&type=style&index=0&id=2f344001&scoped=true&lang=css"

import exportComponent from "D:\\0my-projects\\myweb2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f344001"]])

export default __exports__